const COLS = [
  { title: "Shop",   items: ["All jellabas", "New arrivals", "Limited prints", "Gift cards"] },
  { title: "About",  items: ["Our story", "Craftsmanship", "Sustainability", "Press"] },
  { title: "Help",   items: ["Size guide", "Shipping", "Returns", "Care instructions"] },
  { title: "Follow", items: ["Instagram", "TikTok", "Newsletter", "Contact"] },
];

export function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0C111C] text-[#F4EDE2] border-t border-white/10">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          {COLS.map((c) => (
            <div key={c.title}>
              <p
                className="text-[10px] tracking-[0.22em] uppercase text-[#C8A96A]"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                {c.title}
              </p>
              <ul
                className="mt-4 space-y-2 text-sm text-[#F4EDE2]/80"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                {c.items.map((it) => (
                  <li key={it}>
                    <a href="#" className="hover:text-[#C8A96A] transition-colors">
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col md:flex-row md:items-center md:justify-between gap-6 border-t border-white/10 pt-8">
          <p className="text-3xl" style={{ fontFamily: "Fraunces, serif" }}>
            YABA<span className="align-super text-sm">®</span>
          </p>
          <div
            className="flex flex-wrap items-center gap-3 text-[11px] tracking-[0.16em] uppercase text-[#F4EDE2]/70"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            <span>Visa</span><span className="text-[#C8A96A]">·</span>
            <span>Mastercard</span><span className="text-[#C8A96A]">·</span>
            <span>Amex</span><span className="text-[#C8A96A]">·</span>
            <span>PayPal</span><span className="text-[#C8A96A]">·</span>
            <span>Apple Pay</span><span className="text-[#C8A96A]">·</span>
            <span>Klarna</span><span className="text-[#C8A96A]">·</span>
            <span>Tabby</span>
          </div>
        </div>
        <div
          className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[11px] tracking-[0.16em] uppercase text-[#F4EDE2]/50"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          <p>© 2026 YABA · Handcrafted in Fes, Morocco</p>
          <div className="flex gap-4">
            <a href="#" className="hover:text-[#C8A96A]">Terms</a>
            <a href="#" className="hover:text-[#C8A96A]">Privacy</a>
            <a href="#" className="hover:text-[#C8A96A]">Cookies</a>
            <span className="text-[#F4EDE2]/30">|</span>
            <a href="#" className="text-[#C8A96A]">EN</a>
            <a href="#" className="hover:text-[#C8A96A]">FR</a>
            <a href="#" className="hover:text-[#C8A96A]">AR</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
